var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLuna(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 71,
    viewBox: "0 0 70 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5441_6066)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.6271 70.1478C53.7512 70.1478 69.2543 54.6447 69.2543 35.5207C69.2543 16.3967 53.7512 0.893555 34.6271 0.893555C15.5031 0.893555 0 16.3967 0 35.5207C0 54.6447 15.5031 70.1478 34.6271 70.1478Z",
    fill: "#4B5158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8914 16.368C31.9463 14.8513 36.5101 14.8479 40.6412 16.0944C46.0187 17.7635 50.5584 21.8218 52.9303 26.9155C53.5848 28.3663 54.2115 29.8796 54.2739 31.4932C51.2509 29.741 47.9371 28.6053 44.6163 27.5699C39.3045 25.655 33.7434 24.3253 28.7156 21.6937C27.5452 20.9942 26.0527 20.2774 25.7342 18.8196C25.6061 17.5592 26.9392 16.8562 27.8914 16.368Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6509 28.6267C16.8248 25.441 18.7501 22.4839 21.3644 20.292C22.0293 25.7596 24.3562 31.0437 28.1998 35.0189C32.8087 39.8078 39.374 42.7477 46.0536 42.6369C48.706 42.72 51.2996 42.1071 53.8862 41.6119C51.3411 50.8089 41.2612 56.9137 31.9222 55.4455C26.2849 54.7252 21.0805 51.3872 17.9398 46.6744C14.3974 41.4665 13.5041 34.5514 15.6509 28.6267Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6172 27.5713C47.9379 28.6066 51.2517 29.7424 54.2746 31.4945L54.4789 31.6019C54.7594 33.7107 54.9637 35.861 54.5897 37.9733C53.0696 37.3292 51.8369 36.1969 50.5488 35.1962C48.0695 33.1324 45.5383 30.7708 44.6172 27.5713Z",
    fill: "#4B5158"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5441_6066"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69.2543,
    height: 69.2543,
    fill: "white",
    transform: "translate(0 0.893555)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuna);
export default __webpack_public_path__ + "static/media/luna.6877ad6d9ac0f7e554d4565628ba0cb4.svg";
export { ForwardRef as ReactComponent };